<template>
  <div class="user-page">
    <PageHeader :title="$t('profile.profile')" icon="icon-feather-user" />
    <div uk-grid>
      <div class="uk-width-1-1 uk-width-1-4@m">
        <div class="uk-card-default rounded p-4 profile-summary-card">
          <div class="profile-summary">
            <div class="user-profile-photo profile-avatar-frame">
              <UserProfileAvatar
                  :name="user?.fullname || ''"
                  :photo="user?.photo_link || ''"
                  class="profile-avatar-image"
              />
            </div>
            <div class="profile-summary-content">
              <h4 class="mb-1">{{ user.fullname }}</h4>
              <p class="m-0">
                <i aria-hidden="true" class="icon-feather-briefcase"></i>
                {{ user && user.title ? user.title.name : '-' }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-expand@m">
        <div class="uk-card-default rounded">
          <div class="uk-flex uk-flex-between uk-flex-middle py-3 px-4 profile-card-header">
            <h5 class="mb-0"><i class="icon-feather-user"></i> {{ $t('profile.personal_information') }}</h5>
            <a :uk-tooltip="$t('general.update_myinfo')" @click="$router.push({ name: 'user.update-profile' })">
              <i class="icon-feather-settings"></i> </a>
          </div>
          <hr class="m-0">
          <div class="uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.name') }} </h6>
              <p> {{ user.name }} </p>
            </div>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.surname') }} </h6>
              <p> {{ user.surname }} </p>
            </div>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.dob') }} </h6>
              <p>{{ user.dob }} </p>
            </div>
            <div v-if="!shouldHideEmailField">
              <h6 class="uk-text-bold"> {{ $t('profile.email') }} </h6>
              <p style="overflow:hidden;text-overflow: ellipsis">{{ user.email }}</p>
            </div>
            <div>
              <h6 class=" uk-text-bold"> {{ $t('profile.phone') }} </h6>
              <p>{{ user.phone }} </p>
            </div>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.login_password') }} </h6>
              <p> ******** </p>
            </div>
          </div>
          <hr>
          <div class="uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.login_type') }} </h6>
              <p><i class="icon-feather-check"></i>{{
                  user && this.$t(user.login_type) ?
                      this.$t('general.' + user.login_type?.key_name)
                      :
                      '-'
                }}</p>
            </div>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.authentication_type') }}</h6>
              <p><i class="icon-feather-check"></i>{{
                  user && user.authentication_type ?
                      this.$t('general.' + user.authentication_type?.key_name)
                      :
                      '-'
                }}</p>
            </div>
          </div>
        </div>
        <div class="uk-card-default rounded mt-4">
          <div class="uk-flex uk-flex-between uk-flex-middle py-3 px-4 profile-card-header">
            <h5 class="mb-0"><i class="icon-feather-briefcase"></i> {{ $t('profile.company_profile') }} </h5>
            <a class="d-none" uk-tooltip="title: Bilgilerimi Güncelle; pos: left"
               @click="$router.push({ name: 'user.company-profile' })"> <i class="icon-feather-settings"></i>
            </a>
          </div>
          <hr class="m-0">
          <div class="uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.company_name') }}</h6>
              <p>{{ user && user.company ? user.company?.name : '-' }}</p>
            </div>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.position') }} </h6>
              <p> {{ user && user.position ? user.position?.name : '-' }}</p>
            </div>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.title') }} </h6>
              <p> {{ user && user.title ? user.title?.name : '-' }}</p>
            </div>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.gm_region') }} </h6>
              <p> {{ user && user.region ? user.region?.name : '-' }} </p>
            </div>
            <div>
              <h6 class="uk-text-bold"> {{ $t('profile.unit') }} </h6>
              <p> {{ user && user.department ? user.department?.name : '-' }} </p>
            </div>
            <div v-if="$hasPermission('read_branch')">
              <h6 class="uk-text-bold"> {{ $t('profile.branch') }} </h6>
              <p> {{ user && user.branch ? user.branch?.name : '-' }} </p>
            </div>
          </div>
        </div>

        <!-- Fatura Bilgileri -->
        <div v-if="hasPaymentInIntegration" class="uk-card-default rounded mt-4">
          <div class="uk-flex uk-flex-between uk-flex-middle py-3 px-4 profile-card-header">
            <h5 class="mb-0"><i class="uil-invoice"></i> {{ $t('profile.invoice_info') }} </h5>
            <a uk-tooltip="title: Fatura Bilgilerini Güncelle; pos: left"
               @click="$router.push({ name: 'user.update-invoice' })">
              <i class="icon-feather-settings"/>
            </a>
          </div>
          <hr class="m-0">
          <div class="uk-child-width-1-2@s uk-grid-small p-4" uk-grid>
            <!-- Kurumsal Fatura Bilgileri -->
            <template v-if="payment_info && payment_info.entity_type === 'corporate'">
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.invoice_type') }}</h6>
                <p>{{ $t('profile.corporate') }}</p>
                <p>{{ $t(`profile.${payment_info.entity_type}`) }}</p>

              </div>
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.company_name') }}</h6>
                <p>{{ payment_info.corporate?.company_name || '-' }}</p>
              </div>
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.tax_office') }}</h6>
                <p>{{ payment_info.corporate?.tax_office || '-' }}</p>
              </div>
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.tax_number') }}</h6>
                <p>{{ payment_info.corporate?.tax_number || '-' }}</p>
              </div>
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.address') }}</h6>
                <p>
                  {{ payment_info.corporate?.address || '-' }}<br>
                  {{ payment_info.corporate?.city || '-' }},
                  {{ payment_info.corporate?.state || '-' }}<br>
                  {{ payment_info.corporate?.country || '-' }}
                </p>
              </div>
            </template>

            <!-- Bireysel Fatura Bilgileri -->
            <template v-if="payment_info && payment_info.entity_type === 'individual'">
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.invoice_type') }}</h6>
                <p>{{ $t(`profile.${payment_info.entity_type}`) }}</p>
              </div>
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.full_name') }}</h6>
                <p>{{ payment_info.individual?.first_name_last_name || '-' }}</p>
              </div>
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.tc_number') }}</h6>
                <p>{{ payment_info.individual?.tc || '-' }}</p>
              </div>
              <div>
                <h6 class="uk-text-bold">{{ $t('profile.address') }}</h6>
                <p>
                  {{ payment_info.individual?.address || '-' }}<br>
                  {{ payment_info.individual?.city || '-' }},
                  {{ payment_info.individual?.state || '-' }}<br>
                  {{ payment_info.individual?.country || '-' }}
                </p>
              </div>
            </template>

            <!-- Fatura Bilgisi Yok -->
            <template v-if="!payment_info || !payment_info.entity_type">
              <div class="uk-width-1-1">
                <p class="text-center text-muted">{{ $t('profile.no_invoice_info') }}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import module, { CURRENT_ITEM, GET_USER } from "@/core/services/store/user.module";
import moment from "moment";
import store from "@/core/services";

import module_integration, { BASE_URL, GET_ITEMS, MODULE_NAME, } from "@/core/services/store/integrations.module";
import UserProfileAvatar from "@/view/components/common/UserProfileAvatar.vue";
import PageHeader from "@/view/components/common/PageHeader.vue";

export default {
  name: "Profile",
  components: {
    UserProfileAvatar,
    PageHeader,
  },
  data() {
    return {
      apiURL: 'api/user/self',
      integrations: [],
      hasPaymentInIntegration: false,
      payment_info: {}
    };
  },
  computed: {
    loginLogo() {
      return process.env.BASE_URL + "media/images/anzera-logo-medium.png";
    },
    shouldHideEmailField() {
      const companyId = this.user?.company_id || this.user?.company?.id;
      return Number(companyId) === 489;
    },
    user: {
      get() {
        const storeUser = store.getters[`${this.$options.name}/${CURRENT_ITEM}`];
        if (!storeUser) return null;

        const { name = '', surname = '', dob = null, vat_info = null } = storeUser;

        const formattedUser = {
          ...storeUser,
          dob: dob ? moment(dob).format('YYYY-MM-DD') : '-',
          fullname: `${name} ${surname}`.trim(),
        };

        this.payment_info = vat_info;

        return formattedUser;
      },
      set(value) {
      }
    }
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule)
      }
    }

    registerStoreModule(this.$options.name, module)
    registerStoreModule(MODULE_NAME, module_integration);
  },
  mounted() {
    this.$store.dispatch(this.$options.name + '/' + GET_USER, {
      url: this.apiURL,
      acceptPromise: true,
    })
    this.getResult()
  },
  methods: {
    getResult() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEMS, {
        url: BASE_URL,
        filters: {
          by_user: true
        },
      }).then((response) => {
            this.integrations = response;
            this.hasPaymentInIntegration = response.some(res => {
              return res.group === 'payment' && res.activated_at;
            });
          }
      );
    },
  }
}
</script>

<style scoped>
.user-page {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

.uk-card-default {
  background: #ffffff;
  border: 1px solid #e2e8f0 !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  overflow: hidden;
}

.profile-avatar-frame {
  width: 88px;
  height: 88px;
  flex: 0 0 88px;
  padding: 4px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-summary-card {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%) !important;
}

.profile-summary {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  text-align: left;
}

.profile-summary-content {
  min-width: 0;
}

.profile-summary-content h4 {
  margin: 0;
  color: #1e293b;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.profile-summary-content p {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px !important;
  color: #64748b;
  font-size: 14px;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.profile-summary-content p i {
  flex: 0 0 auto;
  margin-top: 2px;
  color: var(--backgroundColor, #666cff);
  font-size: 15px;
}

.profile-avatar-frame :deep(img),
.profile-avatar-frame :deep(svg) {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.profile-avatar-image {
  width: 100%;
  height: 100%;
  font-size: 32px;
}


@media (max-width: 640px) {
  .user-page {
    padding-left: 12px;
    padding-right: 12px;
  }

  .user-page :deep(.page-header-block),
  .user-page :deep(.page-header-block__left),
  .user-page :deep(.page-header-block__title) {
    min-width: 0;
  }

  .user-page :deep(.page-header-block) {
    gap: 8px;
  }

  .user-page :deep(.page-header-block__title) {
    font-size: 18px;
  }

  .user-page > h3 {
    font-size: 1.25rem;
    margin-bottom: 16px;
  }

  .uk-grid {
    margin-left: 0 !important;
    margin-right: 0 !important;
    row-gap: 8px;
  }

  .uk-grid > * {
    padding-left: 0 !important;
    padding-right: 0 !important;
    width: 100% !important;
  }

  .user-page > .uk-grid > :nth-child(2) {
    margin-top: 0 !important;
  }

  .profile-summary-card {
    margin-bottom: 0 !important;
  }

  .p-4 {
    padding: 16px !important;
  }

  .p-3 {
    padding: 12px !important;
  }

  .profile-card-header {
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 12px 16px !important;
  }

  .profile-card-header h5 {
    font-size: 16px;
    line-height: 1.4;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  .profile-card-header a {
    display: inline-flex;
    flex: 0 0 44px;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    margin-left: auto;
  }

  .profile-summary-card {
    padding: 16px !important;
  }

  .profile-summary {
    gap: 12px;
  }

  .profile-avatar-frame {
    width: 76px;
    height: 76px;
    flex-basis: 76px;
  }

  .profile-summary-content h4 {
    font-size: 18px;
    line-height: 1.4;
    overflow-wrap: anywhere;
  }

  .profile-summary-content p {
    font-size: 14px;
    line-height: 1.5;
    overflow-wrap: anywhere;
  }

  .uk-card-default > .uk-child-width-1-2\@s {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }

  .uk-card-default > .uk-child-width-1-2\@s > div {
    min-width: 0;
    width: 100% !important;
  }

  .uk-card-default h6 {
    margin-bottom: 4px;
    font-size: 14px;
    line-height: 1.4;
  }

  .uk-card-default p {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 1.5;
    overflow-wrap: anywhere;
    word-break: break-word;
  }

  .uk-card-default p[style] {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}
</style>
